import type { UserBadgeReputationRecentFeedback } from 'generated/openapi/types.gen';

import { TIER_REQUIREMENTS_MAP } from '../modals/profileNonToxicModal/constants';

export function getTierRequirementText(
  tier: number,
  recentFeedback?: UserBadgeReputationRecentFeedback,
): string {
  const tierConfig = TIER_REQUIREMENTS_MAP[tier];
  if (!tierConfig) {
    return '';
  }

  if (tier === 1 && tierConfig.altRequirement && recentFeedback) {
    const { totalCount, positiveRatio } = recentFeedback;

    const qualifiesForFirstOption = totalCount >= 3 && positiveRatio === 1;

    const qualifiesForSecondOption = totalCount >= 10 && positiveRatio >= 0.9;

    if (qualifiesForFirstOption) {
      return tierConfig.requirement;
    }

    if (qualifiesForSecondOption) {
      return tierConfig.altRequirement;
    }
  }

  return tierConfig.requirement;
}
